document.addEventListener("DOMContentLoaded", function () {
  const lightbox = document.getElementById('lightbox');
  const lightboxImg = document.getElementById('lightbox-img');
  const closeBtn = document.querySelector('.lightbox-close');

  document.querySelectorAll('.gallery-container img').forEach(img => {
    img.addEventListener('click', function () {
      lightbox.classList.add('show'); // 🔄 ADD show class
      lightbox.style.display = 'flex'; // 💡 Use flex to center image
      lightboxImg.src = this.src;
    });
  });

  function closeLightbox() {
    lightbox.classList.remove('show'); // 🔄 Remove show class
    lightbox.style.display = 'none';
  }

  closeBtn.addEventListener('click', closeLightbox);

  lightbox.addEventListener('click', function (e) {
    if (e.target === lightbox) {
      closeLightbox();
    }
  });

  // Optional: Close on ESC key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeLightbox();
    }
  });
});

